// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
export const harvestAttributeCodeCode = z.string();
export const harvestAttributeCode = z.object({
    code: harvestAttributeCodeCode,
    description: z.string().nullable(),
    created_at: z.date(),
});
export const harvestAttributeCodeInitializer = z.object({
    code: harvestAttributeCodeCode,
    description: z.string().optional().nullable(),
    created_at: z.date().optional(),
});
export const harvestAttributeCodeMutator = z.object({
    code: harvestAttributeCodeCode.optional(),
    description: z.string().optional().nullable(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=HarvestAttributeCode.js.map